var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilled = function SvgIconFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.694 5c-1.517-1.306-5.554-1.742-7.71 1.267C9.825 3.257 5.788 3.694 4.272 5s-4.336 4.275.17 9.94C6.944 18.199 12.006 21 12.006 21s5.062-2.801 7.56-6.06c4.486-5.664 1.688-8.632.171-9.94z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.694 5c-1.517-1.306-5.554-1.742-7.71 1.267C9.825 3.257 5.788 3.694 4.272 5s-4.336 4.275.17 9.94C6.944 18.199 12.006 21 12.006 21s5.062-2.801 7.56-6.06c4.486-5.664 1.688-8.632.171-9.94z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 24.6,
    height: 24.6,
    x: -0.3,
    y: -0.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "0.5 0.5",
    numOctaves: 3,
    seed: 4679,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    width: "100%",
    height: "100%",
    "in": "shape",
    result: "displacedImage",
    scale: 0.6,
    xChannelSelector: "R",
    yChannelSelector: "G"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_10377_16933"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 22.5,
    height: 19.5,
    x: 0.75,
    y: 2.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1 1",
    numOctaves: 3,
    seed: 1449,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    width: "100%",
    height: "100%",
    "in": "shape",
    result: "displacedImage",
    scale: 1,
    xChannelSelector: "R",
    yChannelSelector: "G"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_10377_16933"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "displacedImage"
  }))))));
};
export default SvgIconFilled;